import * as React from "react"
const DownloadIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={13.989} height={14} {...props}>
    <path
      fill="#5078e1"
      d="M6.983 0a.777.777 0 0 0-.766.788v7.45l-1-1a.778.778 0 1 0-1.1 1.1l2.332 2.332a.777.777 0 0 0 1.1 0l2.327-2.343a.778.778 0 1 0-1.1-1.1l-1 1V.787a.777.777 0 0 0-.789-.788ZM2.332 4.285A2.343 2.343 0 0 0 0 6.616v5.052A2.343 2.343 0 0 0 2.332 14h9.326a2.343 2.343 0 0 0 2.332-2.332V6.616a2.343 2.343 0 0 0-2.332-2.332h-1.166a.777.777 0 1 0 0 1.554h1.166a.766.766 0 0 1 .777.777v5.052a.766.766 0 0 1-.777.777H2.332a.766.766 0 0 1-.777-.777V6.616a.766.766 0 0 1 .777-.777H3.5a.777.777 0 1 0 0-1.554Z"
    />
  </svg>
)
export default DownloadIcon